/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportCatalogListResponse {
    getFixupPrototypeFunction() { return ReportCatalogListResponse.fixupPrototype; }

    static newInstance(model: Partial<ReportCatalogListResponse>): ReportCatalogListResponse {
        let obj = Object.assign(new ReportCatalogListResponse(), model);
        ReportCatalogListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportCatalogListResponse>): ReportCatalogListResponse {
        if (!model) return null;
        return ReportCatalogListResponse.newInstance(<ReportCatalogListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportCatalogListResponse) {
        if (!obj) return;

        models.ReportCatalogListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportCatalogListResponse): boolean {
        Object.setPrototypeOf(obj, ReportCatalogListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.categories) {
            for (let val of this.categories) {
                models.ReportCatalogCategory.fixupPrototype(val);
            }
        }
    }

    /**
     * Catalog scopes configured for the deployment, in tab order
     */
    scopes: Array<string>;

    /**
     * Product categories in display order; empty categories are omitted
     */
    categories: Array<models.ReportCatalogCategory>;

}
